<template>
  <div v-if="formCta && !shouldHide">
    <div v-if="!formAsModal" id="cta-form" class="mx-auto bg-white">
      <form-render :form-info="formCta.data.form" :values="trackParams" @submitted="onSubmitted"></form-render>
    </div>
    <Dialog v-else v-model:open="isOpen">
      <DialogScrollContent class="tw-max-w-3xl">
        <DialogHeader>
          <DialogTitle class="form-title-color">{{ formCta.data.form.title }}</DialogTitle>
        </DialogHeader>
        <div class="tw-px-6">
          <form-render
            :form-info="formCta.data.form"
            :show-title="false"
            :values="trackParams"
            @submitted="onSubmitted"
          ></form-render>
        </div>
      </DialogScrollContent>
    </Dialog>
  </div>
</template>

<script>
import $ from 'jquery'
import {
  Dialog,
  DialogHeader,
  DialogScrollContent,
  DialogTitle
} from '@/shadcn/components/ui/dialog'

export default {
  name: 'FormCta',
  components: {
    Dialog,
    DialogHeader,
    DialogScrollContent,
    DialogTitle
  },
  props: {
    callToActions: {
      required: true
    },
    trackParams: {
      default: () => ({})
    },
    forceModal: {
      default: false
    },
    canScrollWithUrl: {
      type: Boolean,
      default: true
    }
  },
  emits: ['submitted'],
  data () {
    return {
      shouldHide: false,
      isOpen: false
    }
  },
  computed: {
    formCta () {
      return this.callToActions.find(cta => cta.type === this.constants.App_Models_CallToAction.TYPE_FORM)
    },
    formAsModal () {
      return this.formCta.data.form_as_modal || this.forceModal
    }
  },
  methods: {
    open () {
      if (this.formAsModal) {
        this.isOpen = true
      } else if (this.canScrollWithUrl) {
        this.$el.scrollIntoView()
      } else {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(this.$el).offset().top
        }, 500)
      }
    },
    onSubmitted (submission) {
      if (submission.form.complete_action === this.constants.App_Models_Form.COMPLETE_ACTION_FORWARD_URL) {
        if (this.formAsModal) {
          this.isOpen = false
        }

        this.shouldHide = true
        this.formCta.show_button = false
      }

      this.$emit('submitted', submission)
    }
  }
}
</script>
